import type { FetchResult } from "@apollo/client";
import type { LazyAction, LazyModule } from "owa-bundling-light";
import type { MailboxInfo } from "owa-client-types";
import type { UserConfigurationArgs } from "owa-graph-schema";
import { lazySetMailboxMessageConfiguration, lazyUpdateUserConfigurationOperation, lazySetUserTheme, } from "../lazyFunctions";
import type * as lazyIndex from "../lazyIndex";

type ServiceOperationLazyAction = LazyAction<(mailboxInfo: MailboxInfo, updates: UserConfigurationArgs) => Promise<FetchResult>, LazyModule<typeof lazyIndex>>;

export type UpdateOperationType = "UserConfiguration" | "MailboxMessageConfiguration" | "UserTheme";

export const updateOperationMap: Record<UpdateOperationType, ServiceOperationLazyAction> = {
    UserConfiguration: lazyUpdateUserConfigurationOperation,
    MailboxMessageConfiguration: lazySetMailboxMessageConfiguration,
    UserTheme: lazySetUserTheme,
};
